const options = {
  rootMargin: '300px 0px',
  threshold: 0.1
};

const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const el = entry.target;
    const html = el.dataset.avisIframe;
    // 1) on injecte le HTML (div + script)
    el.innerHTML = html;

    // 2) on parcourt tous les <script> fraîchement injectés
    el.querySelectorAll('script').forEach(oldScript => {
      const newScript = document.createElement('script');
      // conservation des attributs (src, async, charset…)
      Array.from(oldScript.attributes).forEach(({ name, value }) => {
        newScript.setAttribute(name, value);
      });
      // si c’est un script inline, on copie le contenu
      newScript.textContent = oldScript.textContent;
      // on remplace l’ancien par le nouveau pour déclencher l’exécution
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    obs.unobserve(el);
  });
}, options);

const watch = () => {
  document.querySelectorAll('.avis-lazyload').forEach(el => {
    if (!el.classList.contains('loaded')) {
      observer.observe(el);
      el.classList.add('loaded');
    }
  });
};

document.addEventListener('DOMContentLoaded', watch);
